import VueElement from './vue'

export default class PermissionsConfig extends VueElement {
  static vueComponent = 'permissions-config'

  get props () {
    return {
      paramKey: this.getAttribute('param') ?? null,
      src: this.getAttribute('src') ?? null,
      config: this.getAttribute('value') ? JSON.parse(this.getAttribute('value')) : {}
    }
  }
}
